import "./login.css";

import {useForm} from "react-hook-form";
import Toast from "../libs/Toast";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {setAxiosSetting} from "../libs/axiosInstant";
import React from "react";
import {useQuery} from "react-query";
function Login() {
    //https://codepen.io/ig_design/pen/KKVQpVP

    //const AUTH_URL = process.env.REACT_APP_AUTH_URL
    const FALCON_API_URL = process.env.REACT_APP_FALCON_API_URL
    const navigate = useNavigate();

    const fetchAssociations = async () => {
        const response = await axios.get(`${FALCON_API_URL}/auth_associations`);
        return response.data;
    };
    const { data: associations, isLoading, isError } = useQuery(['associations'], fetchAssociations);

    const {register, handleSubmit, reset, formState: {errors},} = useForm();
    const onSubmit = async (formData) => {
        //console.log(AUTH_URL)
        try {
            const response = await axios.post(`${FALCON_API_URL}/login`, formData, {
                headers: {'Content-Type': 'multipart/form-data',},
            });

            const { data } = response;
            Toast((data.status ? 'success' : 'error'), data.message)
            if(data.status) {
                setAxiosSetting(data.token, data.endpoint)
                localStorage.setItem('api', JSON.stringify(Object.fromEntries(Object.entries(data).filter(([key, val]) => {
                    return !['status', 'message'].includes(key)
                }))));
                reset();
                navigate('/')
            }
        } catch (error) {
            //console.log(error.response.data)
            //console.error("There was an error sending the message!", error);
            Toast('error', error.response.data.message);
        }
    }

    if(isLoading){
        return (
            <div className="loading-container">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <strong role="status">Loading...</strong>
            </div>
        );
    }

    return (
        <div className="section login-container">
            <div className="container">
                <div className="row full-height justify-content-center">
                    <div className="col-12 text-center align-self-center py-5">
                        <div className="section pb-5 pt-5 pt-sm-2 text-center">
                            {/*<h6 className="mb-0 pb-3">
                                <span>Log In </span>
                                <span>Sign Up</span>
                            </h6>
                            <input className="checkbox" type="checkbox" id="reg-log" name="reg-log"/>*/}
                            <img src="myfalconeye.png" alt="Falcon"/>
                            <label htmlFor="reg-log"/>
                            <div className="card-3d-wrap mx-auto">
                                <div className="card-3d-wrapper">
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="card-front">
                                            <div className="center-wrap">
                                                <div className="section text-center">
                                                    <h4 className="mb-4">Message Center</h4>

                                                    <div className="form-group mb-2">
                                                        <select className="form-select form-style"
                                                                id='association_id' {...register('association_id', {required: true})}>
                                                            <option value="">Select an Association</option>
                                                            {associations.map((association, i) =>
                                                                <option key={i} value={association.id}>{association.short_name} - {association.association}</option>
                                                            )}
                                                        </select>
                                                        <i className="input-icon ri-government-line"/>
                                                    </div>
                                                    <div className="form-group">
                                                        <input type="email" {...register('email', {required: true})} className="form-style"
                                                               placeholder="Email" id="email"
                                                               />
                                                        <i className="input-icon ri-at-line"/>
                                                    </div>
                                                    <div className="form-group mt-2">
                                                        <input type="password" {...register('password', {required: true})} className="form-style"
                                                               placeholder="Password" id="password"
                                                               autoComplete="off"/>
                                                        <i className="input-icon ri-key-line"/>
                                                    </div>
                                                    <button type="submit" className="btn mt-4">Login</button>
                                                    {/*<p className="mb-0 mt-4 text-center">
                                                        <a href="#0" className="link">
                                                            Forgot your password?
                                                        </a>
                                                    </p>*/}
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login;
